import * as BABYLON from '@babylonjs/core'

import { state } from './App.js'
import { ColorByModes } from './components/DrawerList.js';

const starsAlpha = .7;
class StarVisualizationData {
    isFilterMatch = false
    displayColor = BABYLON.Color3.White()
    displayScale = 1.0
    row = undefined //Database row for this star

    constructor(row) {
        this.row = row;
    }

    update(data_vis_parameters) {
        let distRange = data_vis_parameters.filters.distance;
        if (!distRange) distRange = [0, 0]

        this.isFilterMatch = true;
        if (this.row.sy_dist < distRange[0] || this.row.sy_dist > distRange[1]) this.isFilterMatch = false;

        //TMP: Until better "real color" determination is added, we're filtering out stars with missing color data
        //if(state.colorByModeChosen == ColorByModes.ST_SPECTYPE && !this.row.st_spectype) this.isFilterMatch = false;

        this.displayScale = 1.0;

        this.displayColor = this.#calculateColor(data_vis_parameters);

        let distRangeSize = distRange[1] - distRange[0];
        let t = (this.row.sy_dist - distRange[0]) / distRangeSize;
        let h = t * 360;
        //this.displayColor = BABYLON.Color3.FromHSV(h, 1, 1);
    }

    #calculateColor(data_vis_parameters) {
        switch (state.colorByModeChosen) {
            case ColorByModes.WHITE:
                return BABYLON.Color3.White();
            case ColorByModes.DISTANCE_HUES:
                {
                    let distRange = data_vis_parameters.filters.distance;
                    let distRangeSize = distRange[1] - distRange[0];
                    let t = (this.row.sy_dist - distRange[0]) / distRangeSize;
                    let h = t * 360;
                    return BABYLON.Color3.FromHSV(h, 1, 1);
                }
            case ColorByModes.DISTANCE_GRAYSCALE:
                {
                    let distRange = data_vis_parameters.filters.distance;
                    let distRangeSize = distRange[1] - distRange[0];
                    let t = 1 - ((this.row.sy_dist - distRange[0]) / distRangeSize);
                    return BABYLON.Color3.White().multiplyByFloats(t, t, t);
                }
            case ColorByModes.ST_SPECTYPE:
                return this.#get_stellar_color(this.row.st_spectype);
        }
        console.log(`ColorByMode error! val=${state.colorByModeChosen}`)
        return BABYLON.Color3.Purple();
    }

    #get_stellar_color(st_spectype) {
        st_spectype = st_spectype || ''
        const match = st_spectype.match(/^([A-Za-z0-9]+)/);
        if (match) {
            const colorMap = {
                'O': '#9bb0ff',
                'B': '#aabfff',
                'A': '#cad7ff',
                'F': '#f8f7ff',
                'G': '#fff4ea',
                'K': '#ffd2a1',
                'M': '#ffcc6f'
            };
    
            const color = colorMap[st_spectype.charAt(0)] || '#888888';
            return BABYLON.Color3.FromHexString(color);
        }
        else {
            const mul = .1;
            const baseColor = BABYLON.Color3.Purple();
            return baseColor.multiplyByFloats(mul, mul, mul);
        }
    }

    applyScalingTransform(matrix) {
        const scale = this.isFilterMatch ? this.displayScale : 0;
        return BABYLON.Matrix.Scaling(scale, scale, scale).multiply(matrix)
    }

    applyColor(buffer, index) {
        buffer.set([this.displayColor.r, this.displayColor.g, this.displayColor.b, starsAlpha], index * 4)
    }
}

function lerp(a, b, t) {
    return a + t * (b - a);
}

export default StarVisualizationData;